import { render, staticRenderFns } from "./DtAssessmentRecord.vue?vue&type=template&id=40ec9471&"
import script from "./DtAssessmentRecord.vue?vue&type=script&lang=js&"
export * from "./DtAssessmentRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports